/**
 * Status lines for a lead's calendar client answering our meeting invitation (PREC-3901) — shown
 * in the thread instead of a message bubble.
 */
export const enInboxCalendarResponse = {
	accepted: "Accepted the meeting invitation",
	tentative: "Tentatively accepted the meeting invitation",
	declined: "Declined the meeting invitation",
	rescheduled: "Proposed a new time for the meeting",
};

/**
 * A meeting invitation the lead sent us (PREC-3902) — one line in the thread when it reached a
 * primary mailbox, and the lead-card preview in place of the client's boilerplate body.
 */
export const enInboxCalendarInvite = {
	received: "Sent a meeting invitation",
	preview: "Meeting invitation: {{title}}",
};
